import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import ProgressSpinner
  from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import { useSelector } from 'react-redux';
import GuidanceConnected from '../../../guidance/GuidanceConnected/GuidanceConnected';
import
ThresholdRangeListViewConnected
  from '../../../guidance/thresholdRanges/ThresholdRangeListViewConnected/ThresholdRangeListViewConnected';
import
ThresholdRangeFormConnected
  from '../../../guidance/thresholdRanges/ThresholdRangeFormConnected/ThresholdRangeFormConnected';
import {
  selectThresholdRangesLoading,
} from '../../../../redux/slices/thresholdRangeSlice/thresholdRangeSlice';
import TagsPage from '../../../guidance/tags/TagsPage/TagsPage';
import RaaRoute from '../../../common/RaaRoute';

function GuidancePage() {
  const thresholdRangesLoading = useSelector(selectThresholdRangesLoading);
  /* istanbul ignore next */
  return (
    <Switch>
      <RaaRoute path="/s/guidance" exact>
        <Redirect to="/s/guidance/threshold-ranges" />
      </RaaRoute>
      <RaaRoute path="/s/guidance/established">
        <GuidanceConnected />
      </RaaRoute>
      <RaaRoute path="/s/guidance/threshold-ranges" exact>
        <ThresholdRangeListViewConnected />
      </RaaRoute>
      <RaaRoute path="/s/guidance/threshold-ranges/new" exact>
        <ThresholdRangeFormConnected />
      </RaaRoute>
      <RaaRoute
        path="/s/guidance/threshold-ranges/:thresholdRangeId"
        exact
        render={(routeProps) => {
          const { match: actionMatch } = routeProps;
          const thresholdRangeId = parseInt(actionMatch.params.thresholdRangeId, 10);
          return !thresholdRangesLoading ? (
            <ThresholdRangeFormConnected thresholdRangeId={thresholdRangeId} />
          ) : (<ProgressSpinner />);
        }}
      />
      <RaaRoute
        path="/s/guidance/threshold-ranges/new/:thresholdRangeId"
        exact
        render={(routeProps) => {
          const { match: actionMatch } = routeProps;
          const thresholdRangeId = parseInt(actionMatch.params.thresholdRangeId, 10);
          return !thresholdRangesLoading ? (
            <ThresholdRangeFormConnected thresholdRangeId={thresholdRangeId} isClone />
          ) : (<ProgressSpinner />);
        }}
      />
      <RaaRoute path="/s/guidance/tags" exact>
        <TagsPage />
      </RaaRoute>
    </Switch>
  );
}

export default GuidancePage;
